import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../../../../modules/infra/ui/button';
export var WalkInListLinkOnly = function (_a) {
    var onOpenWalkInList = _a.onOpenWalkInList;
    return (_jsx(Button.Outline, { type: "button", className: "u-ml-", onClick: onOpenWalkInList, children: "Walk-in List" }));
};
